export default __webpack_public_path__ + "static/media/unf2.c762d76c.jpg";